/**
 * Legacy Settings Guard
 *
 * Blocks access to legacy settings pages in production
 * Allows access in development for maintenance/reference
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { shouldRenderLegacyFeature } from '@/lib/featureFlags';

interface LegacySettingsGuardProps {
  children: React.ReactNode;
}

export function LegacySettingsGuard({ children }: LegacySettingsGuardProps) {
  const shouldRender = shouldRenderLegacyFeature('legacy-settings');

  // In production, redirect to 404
  if (!shouldRender) {
    return <Navigate to="/unauthorized" replace />;
  }

  // In development, render the legacy content
  return <>{children}</>;
}
